import removeLocale from './remove-locale';
import saveMainLocale from './save-main-locale';

export default {
  removeLocale,
  saveMainLocale,
};
